<template>
  <div class="absolute top-45 left-140.5 z-10 w-4.5 h-10">
    <div class="flex items-center justify-center w-full h-full rounded-md bg-glass60">
      <div class="w-1 h-6.5 rounded-full bg-linear-to-b from-[#00FFD1] to-[#EB00FF]" />
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
